import { createAsyncThunk } from '@reduxjs/toolkit';
import authServices from '../../services/authServices';
import {showError,showLinearLoader,closeLinearLoader,showSuccess } from '../slices/commonSlice';
import { SetCookie,deleteCookie,getCookie,clearGuestTickets } from '../../utils/utils';
export const loginAction = createAsyncThunk(
    'auth/login',
    async (payload,thunkApi) => {
      try{
        thunkApi.dispatch(showLinearLoader());
        console.log(payload,"payload from login action");
        const response = await authServices.login(payload);
        console.log(response,"response from login action");
        thunkApi.dispatch(showSuccess(response.data.message));
        thunkApi.dispatch(closeLinearLoader());
        SetCookie("_aps_u",JSON.stringify(response.data.user),30);
        SetCookie("_aps_t",response.data.token,30);
        clearGuestTickets();
        return response.data;
      }catch(error){
        thunkApi.dispatch(closeLinearLoader());
        thunkApi.dispatch(showError(error.response.data.message));
        return thunkApi.rejectWithValue(error.response.data.message);
      }
    }
);

export const guestLoginAction = createAsyncThunk(
    'auth/guestLogin',
    async (payload,thunkApi) => {
      try{
        SetCookie("_aps_u",JSON.stringify({"id":0,"username":"","phone":"","email":""}),30);
        return {"id":0,"username":"","phone":"","email":""};
      }catch(error){
        thunkApi.dispatch(showError('Something went wrong!'));
        return thunkApi.rejectWithValue('Something went wrong!');
      }
    }
);

export const registerAction = createAsyncThunk(
    'auth/register',
    async (payload,thunkApi) => {
    try{
        thunkApi.dispatch(showLinearLoader());
        const response = await authServices.registration(payload);
        thunkApi.dispatch(showSuccess(response.data.message));
        thunkApi.dispatch(closeLinearLoader());
        SetCookie("_aps_u",JSON.stringify(response.data.user),30);
        SetCookie("_aps_t",response.data.token,30);
        clearGuestTickets();
        return response.data;
    }catch(error){
        thunkApi.dispatch(closeLinearLoader());
        thunkApi.dispatch(showError(error.response.data.message));
        return thunkApi.rejectWithValue(error.response.data.message);
    }

    }
);

export const forgotPasswordAction = createAsyncThunk(
    'auth/forgotPassword',
    async (payload, thunkApi) => {
        try{
            const response = await authServices.forgotPassword(payload);
            thunkApi.dispatch(showSuccess(response.data.message));
            return response;
        }catch(error){
            console.log(error);
            if(error.code == "ERR_BAD_REQUEST"){
                thunkApi.dispatch(showError(error.response.data.message));
                return thunkApi.rejectWithValue(error.response.data.message);
            }
            else{
                thunkApi.dispatch(showError(error.message));
                return thunkApi.rejectWithValue(error.message);
            }
        }
    }
);

export const resetPasswordAction = createAsyncThunk(
    'auth/resetPassword',
    async (payload, thunkApi) => {
        try{
            const response = await authServices.resetPassword(payload);
            if(response.data.code == 200){
                thunkApi.dispatch(showSuccess(response.data.message));
                return response;
            }
            else{
                thunkApi.dispatch(showError(response.data.message));
                return thunkApi.rejectWithValue(response.data.message);
            }
        }catch(error){
            thunkApi.dispatch(showError(error.message));
            return thunkApi.rejectWithValue(error.message);
        }
    }
);


export const changePasswordAction = createAsyncThunk(
    'auth/changePassword',
    async (payload) => {
    const response = await authServices.login(payload);
    return response;
    }
);


export const logoutAction = createAsyncThunk(
    'auth/logout',
    async (_,thunkApi) => {
        try{
            thunkApi.dispatch(showLinearLoader());
            var u = JSON.parse(getCookie("_aps_u"));
            if(u.id == 0){
                deleteCookie("_aps_u");
                deleteCookie("_aps_t");
                thunkApi.dispatch(closeLinearLoader());
                return 1;
            }
            const response = await authServices.logout();
            thunkApi.dispatch(showSuccess(response.data.message));
            thunkApi.dispatch(closeLinearLoader());
            deleteCookie("_aps_u");
            deleteCookie("_aps_t");
            return response;
        }catch(error){
        thunkApi.dispatch(closeLinearLoader());
        thunkApi.dispatch(showError(error.response.data.message));
        return thunkApi.rejectWithValue(error.response.data.message);
        }
    }
);

export const loginWithGoogleAction = createAsyncThunk(
    'auth/loginWithGoogle',
    async (payload,thunkApi) => {
        try{
            thunkApi.dispatch(showLinearLoader());
            const response = await authServices.loginWithGoogle(payload);
            thunkApi.dispatch(closeLinearLoader);
            thunkApi.dispatch(showSuccess(response.data.message));
            thunkApi.dispatch(closeLinearLoader());
            SetCookie("_aps_u",JSON.stringify(response.data.user),30);
            SetCookie("_aps_t",response.data.token,30);
            clearGuestTickets();
            return response.data;
        }catch(error){
            thunkApi.dispatch(closeLinearLoader());
            thunkApi.dispatch(showError(error.response.data.message));
            return thunkApi.rejectWithValue(error.response.data.message);
        }
    }
);

/**
 * Completes a redirect-flow Google sign-in (event short hosts). Same
 * persistence as loginWithGoogleAction — the backend answers with the same
 * user + token payload.
 */
export const exchangeGoogleHandoffAction = createAsyncThunk(
    'auth/exchangeGoogleHandoff',
    async (payload,thunkApi) => {
        try{
            thunkApi.dispatch(showLinearLoader());
            const response = await authServices.exchangeGoogleHandoff(payload);
            thunkApi.dispatch(closeLinearLoader());
            thunkApi.dispatch(showSuccess(response.data.message));
            SetCookie("_aps_u",JSON.stringify(response.data.user),30);
            SetCookie("_aps_t",response.data.token,30);
            clearGuestTickets();
            return response.data;
        }catch(error){
            thunkApi.dispatch(closeLinearLoader());
            const message = error?.response?.data?.message || 'Google sign-in failed. Please try again.';
            thunkApi.dispatch(showError(message));
            return thunkApi.rejectWithValue(message);
        }
    }
);

export const loginWithFacebookAction = createAsyncThunk(
    'auth/loginWithFacebook',
    async (payload,thunkApi) => {
        try{
            thunkApi.dispatch(showLinearLoader());
            const response = await authServices.loginWithFacebook(payload);
            thunkApi.dispatch(closeLinearLoader);
            thunkApi.dispatch(showSuccess(response.data.message));
            thunkApi.dispatch(closeLinearLoader());
            SetCookie("_aps_u",JSON.stringify(response.data.user),30);
            SetCookie("_aps_t",response.data.token,30);
            clearGuestTickets();
            return response.data;
          }catch(error){
            thunkApi.dispatch(closeLinearLoader());
            thunkApi.dispatch(showError(error.response.data.message));
            return thunkApi.rejectWithValue(error.response.data.message);
          }
    }
);